// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'underscoreless',
    standalone: false,
})
export class UnderscorelessPipe implements PipeTransform {
    transform (input: any): string {
        if (!input || typeof input !== 'string') {
            return input;
        }
        return input.replace(/_/g, ' ');
    }
}
